import styled from 'styled-components/macro';
import { deviceMax } from 'utils/styles/breakpoints';
import { COLORS } from 'utils/styles/colors';
import { FLEX_CONTAINER } from 'utils/styles/flex';
import { FONTS, FONT_FAMILY } from 'utils/styles/fonts';
import { hoverSettings } from 'utils/constant';

export const SettingsCategories = styled.div`
  border-radius: 50px 0px 0px 50px;
  border-right: 1px solid ${COLORS.lightGray};

  @media only screen and ${deviceMax.laptopLMax} {
    width: 100%;
    ${FLEX_CONTAINER.FlexCenterColumn};
    flex-direction: column-reverse;
  }
`;

export const ImageContainer = styled.div`
  width: auto;
  height: auto;
  position: relative;
`;

export const UpdateAndDelete = styled.input`
  width: 0px;
  height: 0px;
`;

export const UserImageWithUpdateAndDelete = styled.div`
  position: relative;
  width: 150px;
  height: 150px;
  margin: 24px 50px;
  border-radius: 100%;
  overflow: hidden;

  @media only screen and ${deviceMax.laptopLMax} {
    margin: unset;
    width: auto;
    height: auto;
  }
`;

export const ImageSizeValidation = styled.div`
  color: ${COLORS.red};
  ${FONTS.font12};
  ${FONT_FAMILY.FontRegular};
  text-align: center;
  margin-top: 20px;
`;

export const RemoveAndUpdateButtons = styled.div`
  ${FLEX_CONTAINER.FlexCenterColumn}
  gap: 10px;
  position: absolute;
  bottom: 0px;
  width: 100%;
  padding: 0px 30px;
  opacity: 0;

  @media only screen and ${deviceMax.laptopLMax} {
    ${FLEX_CONTAINER.FlexRow};
    align-items: flex-start;
    padding: 15px 15px 15px 50px;
    gap: 30px;
    opacity: 1;
  }

  &:hover {
    opacity: 1;
  }
`;

export const UpdateImageButton = styled.button`
  width: 100%;
  height: 20px;
  text-align: center;
  background: ${COLORS.darkGray};
  color: ${COLORS.black};
  ${FONTS.font14};
  ${FONT_FAMILY.FontMedium};
  border-radius: 16px;
  cursor: pointer;

  @media only screen and ${deviceMax.laptopLMax} {
    display: none;
  }
`;

export const IconImg = styled.img`
  display: none;
  cursor: pointer;
  width: 24px;

  @media only screen and ${deviceMax.laptopLMax} {
    display: block;
  }
`;

export const UserImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;

  @media only screen and ${deviceMax.laptopLMax} {
    width: 200px;
    height: 200px;
    display: ${({ categoryName }) =>
      categoryName === hoverSettings.password ||
      categoryName === hoverSettings.deleteAccount
        ? 'none'
        : 'block'};
  }

  &:hover + ${RemoveAndUpdateButtons} {
    opacity: 1;
  }
`;

export const UserName = styled.div`
  width: 200px;
  margin: auto;
  text-align: center;
  ${FONT_FAMILY.FontRegular};
  ${FONTS.font20};
  color: ${COLORS.black};
  word-wrap: break-word;

  @media only screen and ${deviceMax.laptopLMax} {
    display: none;
  }
`;

export const UserEmail = styled.div`
  width: 100%;
  text-align: center;
  ${FONT_FAMILY.FontRegular};
  ${FONTS.font16};
  color: ${COLORS.mainColor_op7};
  padding-bottom: 40px;

  @media only screen and ${deviceMax.laptopLMax} {
    display: none;
  }
`;

export const CategoriesSection = styled.div`
  width: 100%;
  padding-bottom: 100px;
  ${FLEX_CONTAINER.FlexSpaceBetweenColumn}

  @media only screen and ${deviceMax.laptopLMax} {
    ${FLEX_CONTAINER.FlexCenterRow};
    padding-bottom: unset;
    background: ${COLORS.ultralightGray};
    margin-top: 20px;
    margin-bottom: 20px;
  } ;
`;

export const CategoryTextField = styled.div`
  width: 100%;
  padding: 10px 58px;
  border-top: 1px solid ${COLORS.lightGray};
  color: ${COLORS.mainColor};
  ${FONT_FAMILY.FontRegular};
  cursor: pointer;

  &.active {
    ${FONT_FAMILY.FontMedium};
  }

  &:hover {
    ${FONT_FAMILY.FontMedium};
  }

  &:nth-last-child(1) {
    border-bottom: 1px solid ${COLORS.lightGray};

    @media only screen and ${deviceMax.laptopLMax} {
      border-bottom: none;
    }
  }

  @media only screen and ${deviceMax.laptopLMax} {
    width: 100%;
    text-align: center;
    padding: 20px;
    border-bottom: none;
  }

  @media only screen and ${deviceMax.tablet} {
    ${FONTS.font12}
    padding: 10px
  }
`;
